import * as yup from 'yup';
import moment from 'moment';

import createSingularContainer from '@components/Singular/createSingularContainer'

import TimesheetSingular from './TimesheetSingular'
import statuses from '@server/constants/statuses/timesheet-statuses'

import { TimesheetModel } from '@modules/timesheet/timesheet.module'

import { calculateWeeksWorked } from '@utils/weeks'
import { calculateRate } from '@utils/rates'

export default createSingularContainer({
	component: TimesheetSingular,
	resource: 'timesheet',
	defaultValues: TimesheetModel.getDefaults(),
	formConfig: [{
		label: "",
		fields: TimesheetModel.getFieldProps([
			'status',
			'client.clientID',
			'client.consultant',
			'weekEnding',
			'taxWeek',
		]),
	}],
	validationSchema: TimesheetModel.getValidationSchema(),
	mapDataToCSV: (data) => {

		const client = data.client ? data.client : { consultant: {} };
		const status = data.status ? data.status : {};

		const dateFormat = 'DD/MM/YYYY';
		const output = [
			['Client Name', client.label],
			['Client ID', client.clientID],
			['Assigned Consultant', client.consultant ? client.consultant.label : ''],
			['Week Ending', moment(data.weekEnding).format(dateFormat)],
			['Tax Week Number', data.taxWeek],
			['Timesheet Status', status.label],
			[]
		];

		// add timesheet lines to output
		output.push(['Weeks Worked', 'Name', 'Payroll No.', 'JobType', 'Rate', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'Total Hours', 'Total Cost']);

		data.timesheetLines && data.timesheetLines.forEach(line => {

			const startDate = line.candidate.clientStartDates.find(o => o.client === client._id).startDate;
			const weeksWorked = `${calculateWeeksWorked(startDate, data.weekEnding)} (Started ${moment(startDate).format(dateFormat)})`;
			const rate = calculateRate(client, line.candidate, data.weekEnding, line.jobType._id);
			
			output.push([
				weeksWorked,
				line.candidate.label, 
				line.candidate.payrollNo,
				line.jobType.label,
				isNaN(rate) ? rate : `£${rate}`,
				...line.hours,
				line.totalHours,
				line.totalCost,
			])

		})

		return output;
	},
	mapDataToCSVFilename: (data) => {
		if(!data.client || !data.client.label) return '';
		const label = data.client.label.replace(/\s+/g, '-').toLowerCase();
		const weekEnding = moment(data.weekEnding).format('YYYYMMDD');
		return `h1export-timesheet-${label}-weekEnding_${weekEnding}-exported_${moment().format('YYYYMMDD')}.csv`;
	},
});



// WEBPACK FOOTER //
// ./src/scenes/Timesheets/TimesheetContainer.jsx